import { Events } from "../helpers/events";

export class SliderDots {

  static cssClass = 'c-sliderdots';

  constructor($el = null) {

    this.$el = $el;

    // https://github.com/tc39/proposal-object-rest-spread
    this.defaultConfig = {
      // todo
    };

  }

  static onBoot() {

    Events.delegate.on('click', `.${SliderDots.cssClass}--archive li`, (event) => {
      event.target.closest('.c-card1').querySelector('.c-slider').instance.slider.slideTo( parseInt( event.target.dataset.slide ), 1000 );
      event.target.closest('.c-card1').querySelectorAll(`.${SliderDots.cssClass} li`).forEach(element => {
          element.classList.remove("active");
      });
      event.target.classList.add('active');
    });

    Events.delegate.on('click', `.${SliderDots.cssClass}--single-product li`, (event) => {
      event.target.closest('.single-product-area').querySelector('.c-slider--main-slider').instance.slider.slideTo( parseInt( event.target.dataset.slide ), 1000 );
      event.target.closest('.single-product-area').querySelector('.c-slider--main-slider .c-slider').instance.slider.slideTo( 0, 1000 );
      event.target.closest('.c-product-info').querySelectorAll(`.${SliderDots.cssClass} li`).forEach(element => {
          element.classList.remove("active");
      });
      event.target.classList.add('active');
    });

  }

};
